export class DojoAPIHttp {
	constructor(path="/rpc/DojoAPI/json", server="", _timeout=0) {
		this._id = 0;
		this._timeout = 0;
		if (""==server) {
			server = document.location.protocol + "//" + document.location.host;
		}
		this.url = server + path;
		this._headers = {
			"Accept": "application/json",
			"Content-Type":"application/json"
		};
	}
	setTimeout (ts) {
		this._timeout = ts;
	}	
	reject(reject, err) {
		reject(err);
	}
	headers() {
		return this._headers;
	}
	rpc (method, params) {
		// params comes in as an 'arguments' object, so we need to convert
		// it to an array
		params = Array.prototype.slice.call(params);

		return new Promise( (resolve, reject)=>{		
			fetch(this.url + "?" + method, {
				method: 'POST',
				headers: this.headers(),
				body: JSON.stringify({ id: this._id++, method:method, params: params })
			})
			.then( (res)=>{
				if (!res.ok) {
					let err = new Error(res.statusText);
					err.response = res;
					throw err;
				}
				return res.json();
			}).then( (js)=>{
				if (null!=js.error) {
					throw js.error;
				}
				if (null!=js.result) {
					resolve(js.result);
					return;
				}
				resolve(null);
				return;
			} )
			.catch( (err)=>{
				this.reject(reject, err);
			})
		});
	}
	
	Error() {
		return this.rpc("Error",  arguments );
	}
	
	LoginUser(emailOrMobile,password) {
		return this.rpc("LoginUser",  arguments );
	}
	
	Logout() {
		return this.rpc("Logout",  arguments );
	}
	
	StudentResetPasswordByEmailOrMobile(emailOrMobile) {
		return this.rpc("StudentResetPasswordByEmailOrMobile",  arguments );
	}
	
	StudentRegisterByEmailOrMobile(emailOrMobile) {
		return this.rpc("StudentRegisterByEmailOrMobile",  arguments );
	}
	
	NewDojo(name,parentId,offset) {
		return this.rpc("NewDojo",  arguments );
	}
	
	GetDojo(id) {
		return this.rpc("GetDojo",  arguments );
	}
	
	SaveDojo(d) {
		return this.rpc("SaveDojo",  arguments );
	}
	
	DeleteDojo(dojo) {
		return this.rpc("DeleteDojo",  arguments );
	}
	
	DeleteClassRecord(classRecordId) {
		return this.rpc("DeleteClassRecord",  arguments );
	}
	
	DojosForUser() {
		return this.rpc("DojosForUser",  arguments );
	}
	
	ClassTypes() {
		return this.rpc("ClassTypes",  arguments );
	}
	
	SetClassRecordNotes(classRecordId,notes) {
		return this.rpc("SetClassRecordNotes",  arguments );
	}
	
	SetClassRecordTitle(classRecordId,title) {
		return this.rpc("SetClassRecordTitle",  arguments );
	}
	
	SetClassRecordType(classRecordId,classTypeId) {
		return this.rpc("SetClassRecordType",  arguments );
	}
	
	SetClassRecordTimes(crId,dateString,startString,endString) {
		return this.rpc("SetClassRecordTimes",  arguments );
	}
	
	StudentAttendanceForClassRecord(crId) {
		return this.rpc("StudentAttendanceForClassRecord",  arguments );
	}
	
	StudentAbsenceForClassRecord(crId) {
		return this.rpc("StudentAbsenceForClassRecord",  arguments );
	}
	
	StudentsForClassRecord(crId) {
		return this.rpc("StudentsForClassRecord",  arguments );
	}
	
	AddStudentToClassRecord(classRecordId,studentId,attendanceTypeId) {
		return this.rpc("AddStudentToClassRecord",  arguments );
	}
	
	RemoveStudentFromClassRecord(classRecordId,studentId) {
		return this.rpc("RemoveStudentFromClassRecord",  arguments );
	}
	
	SetStudentClassRecordAttendanceType(classRecordId,studentId,attendanceTypeId) {
		return this.rpc("SetStudentClassRecordAttendanceType",  arguments );
	}
	
	AttendanceTypes() {
		return this.rpc("AttendanceTypes",  arguments );
	}
	
	AttendanceTypesWithAbsence() {
		return this.rpc("AttendanceTypesWithAbsence",  arguments );
	}
	
	LoadTechniques() {
		return this.rpc("LoadTechniques",  arguments );
	}
	
	TechniqueSearch(classRecordId,techniqueSearch) {
		return this.rpc("TechniqueSearch",  arguments );
	}
	
	AddTechniqueToClassRecord(classRecordId,technique) {
		return this.rpc("AddTechniqueToClassRecord",  arguments );
	}
	
	RemoveTechniqueFromClassRecord(classRecordId,technique) {
		return this.rpc("RemoveTechniqueFromClassRecord",  arguments );
	}
	
	LoadClassRecordTechniques(classRecordId) {
		return this.rpc("LoadClassRecordTechniques",  arguments );
	}
	
	ClassRecordSummaryForPeriod(dojoId,start,end) {
		return this.rpc("ClassRecordSummaryForPeriod",  arguments );
	}
	
	ClassRecordSummarySearch(search) {
		return this.rpc("ClassRecordSummarySearch",  arguments );
	}
	
	DojoAttendanceByDate(dojoId) {
		return this.rpc("DojoAttendanceByDate",  arguments );
	}
	
	StudentAttendanceByDate(studentId) {
		return this.rpc("StudentAttendanceByDate",  arguments );
	}
	
	DeleteAspect(aspectId) {
		return this.rpc("DeleteAspect",  arguments );
	}
	
	LoadTechniquesForArtLimited(artId,from,to) {
		return this.rpc("LoadTechniquesForArtLimited",  arguments );
	}
	
	LoadTechniquesForArt(artId) {
		return this.rpc("LoadTechniquesForArt",  arguments );
	}
	
	DeleteTechnique(techniqueId) {
		return this.rpc("DeleteTechnique",  arguments );
	}
	
	SaveTechnique(t) {
		return this.rpc("SaveTechnique",  arguments );
	}
	
	DeleteStudent(dojoId,studentId) {
		return this.rpc("DeleteStudent",  arguments );
	}
	
	FormsForDojo(dojoId) {
		return this.rpc("FormsForDojo",  arguments );
	}
	
	FormsAndInputsForDojoRefType(dojoId,refType,refId) {
		return this.rpc("FormsAndInputsForDojoRefType",  arguments );
	}
	
	FormsForDojoRefType(dojoId,refType) {
		return this.rpc("FormsForDojoRefType",  arguments );
	}
	
	SaveForm(f) {
		return this.rpc("SaveForm",  arguments );
	}
	
	LoadFormInput(formId,refId) {
		return this.rpc("LoadFormInput",  arguments );
	}
	
	SaveFormInput(fi) {
		return this.rpc("SaveFormInput",  arguments );
	}
	
	DeleteForm(formId) {
		return this.rpc("DeleteForm",  arguments );
	}
	
	SendShortMessage(toIds,txt) {
		return this.rpc("SendShortMessage",  arguments );
	}
	
	SendEmailMessage(toIds,title,text) {
		return this.rpc("SendEmailMessage",  arguments );
	}
	
	StudentById(studentId) {
		return this.rpc("StudentById",  arguments );
	}
	
	StudentsForDojo(dojoId) {
		return this.rpc("StudentsForDojo",  arguments );
	}
	
	MergeTechniques(fromId,toId) {
		return this.rpc("MergeTechniques",  arguments );
	}
	
	StudentAttendance(studentId,dojoId,dates) {
		return this.rpc("StudentAttendance",  arguments );
	}
	
	StudentAttendanceSearch(sas) {
		return this.rpc("StudentAttendanceSearch",  arguments );
	}
	
	Version() {
		return this.rpc("Version",  arguments );
	}
	
	flatten(callback, context=null) {
		return function(argsArray) {
			callback.apply(context, argsArray);
		}
	}
}

// Define the class in the window and make AMD compatible
window.DojoAPI = DojoAPIHttp;
if (("function" == typeof window.define) && (window.define.amd)) {
	window.define("DojoAPI", [], function() { return window.DojoAPI; });
}
